import * as url from "../url_helper";

import { post,get } from "../api_helper";

export const addDealer = data => post(url.ADD_DEALER, data);

export const getDealer = data => post(url.GET_DEALER, data);

export const updateDealerStatus = data => post(url.UPDATE_DEALER_STATUS, data);

export const editDealer = data => post(url.EDIT_DEALER, data);

export const getDealerById = data => post(url.GET_ONE_DEALER, data);

export const deleteDealerById = data => post(url.DELETE_DEALER, data);

export const getDealerOptions = () => get(url.GET_DEALER_OPTIONS);

export const getShipToPartyList = data => post(url.GET_SHIP_TO_PARTY_LIST, data);
